import type { AppSerialized } from '@playq/octopus2-apps';
import type { PermsSerialized, AccessLevel, PermModule } from '@playq/octopus2-auth';

interface IAppInitialState {
  app?: AppSerialized;
  perms?: PermsSerialized;
  pending: boolean;
  error?: string;
}

export interface IAppSelectPayload {
  app: AppSerialized;
}

export interface IModulePerms {
  canRead: boolean;
  canWrite: boolean;
  canWriteLive: boolean;
}

export type IPermissionsAccess = Record<PermModule, AccessLevel>;

export const initialAppState: IAppInitialState = {
  pending: false,
};
